import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ColumnaTabla } from '../models/Tabla';
@Injectable({
    providedIn: 'root'
})
export class MenuState {

    public items_menu: MenuItem[] = [
        { label: 'LEADS', icon: 'pi pi-users', routerLink: '/panelAdministrador' },
        { label: 'Administradores', icon: 'pi pi-user', routerLink: '/gestion/administradores' },
        { label: 'Distribuidores', icon: 'pi pi-sitemap', routerLink: '/gestion/distribuidores' },
    ];
    public columnas_administradores: ColumnaTabla[] = [
        { field: 'id', header: 'ID', type: 'number', filter: true },
        { field: 'usuario', header: 'Nombre', type: 'string', filter: true },
        { field: 'email', header: 'Correo Electrónico', type: 'string', filter: true },
        { field: 'rol', header: 'Rol', type: 'string', filter: true },
    ];
    public columnas_distribuidores: ColumnaTabla[] = [
        { field: 'nombre_comercial', header: 'Nombre Comercial', type: 'string', filter: true },
        { field: 'nombre_distribuidor', header: 'Distribuidor', type: 'string', filter: true },
        { field: 'user_retail_x', header: 'User Retail X', type: 'string', filter: true },
        { field: 'telefono', header: 'Teléfono', type: 'string', filter: true },
        { field: 'cif_empresa', header: 'CIF', type: 'string', filter: true },
        { field: 'alias', header: 'Alias', type: 'string', filter: true },
    ];
    public items_opciones: MenuItem[] = [
        { label: 'Crear Administrador', routerLink: '/nuevoRegistroAdmin/administrador' },
        { label: 'Crear Distribuidor', routerLink: '/nuevoRegistroAdmin/distribuidor' },
    ];
}